import { LeftNavLink, NavLinkBadgeStatus } from '@fluentsms/agentnet-web-components';
import { ReactElement } from 'react';

export type LeftNavLinkWithCondition = LeftNavLink & {
  condition?: boolean;
  subLinks?: LeftNavLinkWithCondition[];
};

export const useLeftNavLink = () => {
  const processSubLinks = (subLinks: LeftNavLinkWithCondition[]): LeftNavLink[] => {
    return subLinks
      .filter((subLink) => subLink.condition !== false)
      .map((subLink) => ({
        text: subLink.text,
        url: subLink.url,
        subLinks: subLink.subLinks ? processSubLinks(subLink.subLinks) : undefined,
        exact: subLink.exact,
      }));
  };

  const createLink = (
    condition: boolean,
    icon: ReactElement,
    text: string,
    url: string,
    subLinks: LeftNavLinkWithCondition[] | null = null,
    exact?: boolean,
    status?: NavLinkBadgeStatus,
    badgeTooltip?: string,
  ): LeftNavLink[] => {
    const filteredSubLinks = subLinks ? processSubLinks(subLinks) : [];

    return condition
      ? [
          {
            icon,
            text,
            url,
            subLinks: filteredSubLinks.length > 0 ? filteredSubLinks : undefined,
            testId: `leftnav-link-${text.toLocaleLowerCase()}`,
            exact,
            status,
            badgeTooltip,
          },
        ]
      : [];
  };

  return {
    createLink,
  };
};
